module.exports = __webpack_public_path__ + "static/media/favicon.d9b40862.ico";